export const BUSINESS = {
  name: "Premium Property Care",
  phone: "289-257-5235",
  phoneHref: "tel:+12892575235",
  email: "Inquiries@premiumpropertycare.ca",
  emailHref: "mailto:Inquiries@premiumpropertycare.ca",
  region: "Niagara Region, Ontario",
  startingPrice: 135,
  logo:
    "https://customer-assets.emergentagent.com/job_lawn-hedge-trim/artifacts/q5pj8b67_PREMIUM%20PROPERTY%20CARE%202.png",
};

export const SERVICES = [
  {
    key: "lawn-care",
    title: "Lawn Care",
    blurb:
      "Fertilizing, aerating, edging and seasonal upkeep that keeps your turf showroom-ready.",
    season: "Summer",
  },
  {
    key: "lawn-mowing",
    title: "Lawn Mowing",
    blurb:
      "Weekly or bi-weekly cuts with precision lines, clean edges and tidy clippings every visit.",
    season: "Summer",
  },
  {
    key: "hedge-trimming",
    title: "Hedge Trimming",
    blurb:
      "Crisp lines, balanced shapes, and healthy growth. Cedars, boxwoods, privets — handled.",
    season: "Summer",
  },
  {
    key: "tree-trimming",
    title: "Tree Trimming",
    blurb:
      "Safe pruning for small to mid-sized trees, with full clean-up and haul-away included.",
    season: "Summer",
  },
  {
    key: "patios",
    title: "Patios & Hardscapes",
    blurb:
      "Patio repair, leveling, sealing and refresh. We make tired stone look brand new.",
    season: "Summer",
  },
  {
    key: "junk-removal",
    title: "Junk Removal",
    blurb:
      "Old furniture, appliances, yard waste, renovation debris, hoarder clean-outs, estate clean-outs. Same-day haul-away — we lift it, load it, dispose of it.",
    season: "Year-round",
  },
  {
    key: "backyard-makeover",
    title: "Backyard Makeovers",
    blurb:
      "End-to-end transformations: design ideas, fresh sod, mulch, planters and finishing.",
    season: "Summer",
  },
  {
    key: "bin-washing",
    title: "Garbage Bin Washing",
    blurb:
      "Curbside hot-wash and deodorizing — your bins back home clean, sanitized, and odor-free.",
    season: "Year-round",
  },
  {
    key: "snow-removal",
    title: "Snow Removal",
    blurb:
      "Driveways, walkways and entries cleared before the morning rush — every storm.",
    season: "Winter",
  },
  {
    key: "salting",
    title: "Salting",
    blurb:
      "Eco-conscious salting and de-icing to keep families and customers safe on every surface.",
    season: "Winter",
  },
  {
    key: "snow-plow",
    title: "Snow Plowing",
    blurb:
      "Commercial-grade plowing for laneways, lots and long driveways across the Niagara Region.",
    season: "Winter",
  },
];

export const MEDIA = {
  heroBg:
    "https://images.unsplash.com/photo-1759602602326-a4e9646514a6?auto=format&fit=crop&w=2200&q=80",
  snowPlow:
    "https://images.unsplash.com/photo-1676363707718-eabe464ca9ae?auto=format&fit=crop&w=1600&q=80",
  hedge:
    "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&w=1600",
  patio:
    "https://images.unsplash.com/photo-1657383543451-e47d1589195d?auto=format&fit=crop&w=1600&q=80",
  lawn:
    "https://images.unsplash.com/photo-1592417817098-8fd3d9eb14a5?auto=format&fit=crop&w=1600&q=80",
  junkRemoval:
    "https://images.pexels.com/photos/7464689/pexels-photo-7464689.jpeg?auto=compress&cs=tinysrgb&w=1800",
  junkPile:
    "https://images.pexels.com/photos/9714795/pexels-photo-9714795.jpeg?auto=compress&cs=tinysrgb&w=1600",
  backyard:
    "https://images.unsplash.com/photo-1759602602326-a4e9646514a6?auto=format&fit=crop&w=1800&q=80",
  bins:
    "https://images.pexels.com/photos/36086364/pexels-photo-36086364.jpeg?auto=compress&cs=tinysrgb&w=1600",
  snowRemoval:
    "https://images.unsplash.com/photo-1704578424157-223c3ad72870?auto=format&fit=crop&w=1600&q=80",
  salting:
    "https://images.pexels.com/photos/35826495/pexels-photo-35826495.jpeg?auto=compress&cs=tinysrgb&w=1600",
  // Cleaning service
  cleaningHero:
    "https://images.pexels.com/photos/6196239/pexels-photo-6196239.jpeg?auto=compress&cs=tinysrgb&w=2200",
  cleaningVacuum:
    "https://images.pexels.com/photos/6195949/pexels-photo-6195949.jpeg?auto=compress&cs=tinysrgb&w=1600",
  cleaningBathroom:
    "https://images.pexels.com/photos/5591985/pexels-photo-5591985.jpeg?auto=compress&cs=tinysrgb&w=1400",
  cleaningKitchen:
    "https://images.pexels.com/photos/4239129/pexels-photo-4239129.jpeg?auto=compress&cs=tinysrgb&w=1400",
  cleaningDetail:
    "https://images.pexels.com/photos/4008518/pexels-photo-4008518.jpeg?auto=compress&cs=tinysrgb&w=1400",
  cleaningLiving:
    "https://images.pexels.com/photos/4107160/pexels-photo-4107160.jpeg?auto=compress&cs=tinysrgb&w=1400",
  cleaningPortrait:
    "https://images.pexels.com/photos/6195119/pexels-photo-6195119.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

// Cleaning service page data
export const CLEANING_TYPES = [
  {
    key: "residential",
    title: "Residential Cleaning",
    priceFrom: "From $800+ / month",
    blurb:
      "Homes, apartments, condos. From top-to-bottom whole-house cleans to weekly maintenance — every room, every time.",
    photo:
      "https://images.pexels.com/photos/6195277/pexels-photo-6195277.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    key: "commercial",
    title: "Commercial Cleaning",
    priceFrom: "From $2,000+ / month",
    blurb:
      "Offices, retail, small businesses. Sparkling common areas, sanitized restrooms and desks — after-hours or before opening.",
    photo:
      "https://images.pexels.com/photos/4107160/pexels-photo-4107160.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    key: "move-in-out",
    title: "Landlord & Tenant Clean-Outs",
    priceFrom: "Quoted per project",
    blurb:
      "Move-ins, move-outs, end-of-lease. Handoff a rental spotless — inside cabinets, appliances, walls, baseboards.",
    photo:
      "https://images.pexels.com/photos/6196685/pexels-photo-6196685.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    key: "deep-clean",
    title: "Deep Cleans",
    priceFrom: "Quoted per project",
    blurb:
      "Seasonal, post-renovation or post-party. We tackle the things regular cleans miss — grout, vents, blinds, baseboards.",
    photo:
      "https://images.pexels.com/photos/4239129/pexels-photo-4239129.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    key: "party-cleanup",
    title: "Party & Event Clean-Ups",
    priceFrom: "Quoted per event",
    blurb:
      "Wedding, birthday, holiday or backyard bash — we handle the aftermath so you can enjoy the memories. Kitchens, floors, bathrooms, trash & recycling.",
    photo:
      "https://images.pexels.com/photos/6196692/pexels-photo-6196692.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
];

export const CLEANING_FREQUENCIES = [
  {
    key: "weekly",
    title: "Weekly",
    sub: "Best value · most homes",
    perks: [
      "Same crew every visit",
      "Best rate — locked in",
      "Priority scheduling",
      "Keeps the whole house effortless",
    ],
    featured: true,
  },
  {
    key: "biweekly",
    title: "Bi-Weekly",
    sub: "Most popular",
    perks: [
      "Great balance of cost & upkeep",
      "Same crew every visit",
      "Locked-in rate",
      "Add-on deep-cleans on request",
    ],
  },
  {
    key: "monthly",
    title: "Monthly",
    sub: "Light-touch maintenance",
    perks: [
      "Refresh every 4 weeks",
      "Perfect for tidy households",
      "One-off deep cleans on request",
      "No contract — cancel anytime",
    ],
  },
  {
    key: "one-time",
    title: "One-Time / Clean-Outs",
    sub: "Move-ins, move-outs, deep cleans",
    perks: [
      "Landlord & tenant clean-outs",
      "Post-renovation clean-up",
      "Estate & seasonal deep cleans",
      "Quoted per project",
    ],
  },
];

export const CLEANING_WHATS_INCLUDED = [
  "Dusting all surfaces & fixtures",
  "Vacuuming carpets & floors",
  "Mopping hard floors",
  "Kitchen: counters, appliances, sink",
  "Bathrooms: tubs, toilets, mirrors",
  "Bedrooms: beds made, tidied",
  "Trash removal & bin lining",
  "Interior windows (on request)",
  "Baseboards & light switches",
  "Eco-friendly products available",
];

export const CLEANING_WHY_US = [
  {
    stat: "10+",
    label: "Years in business",
  },
  {
    stat: "100%",
    label: "Insured & bonded crews",
  },
  {
    stat: "5★",
    label: "Client-rated across Niagara",
  },
  {
    stat: "Same",
    label: "Crew every visit",
  },
];

// Finished-work portfolio shots
export const GALLERY = [
  {
    key: "mulching",
    title: "Mulching",
    sub: "Premium black & red bark — clean, sharp",
    url: "https://images.pexels.com/photos/2453600/pexels-photo-2453600.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    key: "hedging",
    title: "Hedging",
    sub: "Crisp, balanced lines",
    url: "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    key: "stonework",
    title: "Stone Work & Patios",
    sub: "Interlock walkways, pavers & sealing",
    url: "https://images.pexels.com/photos/36779942/pexels-photo-36779942.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    key: "junk-removal-gallery",
    title: "Junk Removal",
    sub: "Loaded, hauled, gone — same day",
    url: "https://images.pexels.com/photos/7464689/pexels-photo-7464689.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    key: "weeding",
    title: "Weeding & Clean-ups",
    sub: "Bed-by-bed, hand pulled",
    url: "https://images.unsplash.com/photo-1748432171507-c1d62fe2e859?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "lawn-finish",
    title: "Cut & Striped Lawn",
    sub: "Showroom-ready turf",
    url: "https://images.unsplash.com/photo-1721138941961-cb245dd928af?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "backyard",
    title: "Backyard Makeover",
    sub: "Full property transformations",
    url: "https://images.unsplash.com/photo-1759602602326-a4e9646514a6?auto=format&fit=crop&w=1400&q=80",
  },
];

// Equipment fleet
export const EQUIPMENT = [
  {
    key: "zero-turn",
    title: "Zero-Turn Ride-On Mowers",
    sub: "Commercial Scag-class machines for large properties",
    url: "https://images.unsplash.com/photo-1637269820082-d4ad72e2ad75?auto=format&fit=crop&w=1400&q=80",
    badge: "Summer",
    size: "lg",
  },
  {
    key: "ride-on",
    title: "Ride-On Mowers",
    sub: "Acreage, slopes, big yards — done fast",
    url: "https://images.unsplash.com/photo-1630709437018-854d4f63a856?auto=format&fit=crop&w=1400&q=80",
    badge: "Summer",
  },
  {
    key: "push-mower",
    title: "Push Mowers",
    sub: "Precision cuts for residential lawns",
    url: "https://images.unsplash.com/photo-1590820292118-e256c3ac2676?auto=format&fit=crop&w=1400&q=80",
    badge: "Summer",
  },
  {
    key: "trimmers",
    title: "Weed Wackers & Edgers",
    sub: "Clean lines along walks, beds and fences",
    url: "https://images.unsplash.com/photo-1746436576978-21632bf9790d?auto=format&fit=crop&w=1400&q=80",
    badge: "Summer",
  },
  {
    key: "hedgers",
    title: "Hedge Trimmers",
    sub: "Cordless and gas — sculpted, healthy hedges",
    url: "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&w=1400",
    badge: "Summer",
  },
  {
    key: "snow-plow-truck",
    title: "Snow Plow Trucks",
    sub: "Long driveways and commercial lots",
    url: "https://images.unsplash.com/photo-1676363707718-eabe464ca9ae?auto=format&fit=crop&w=1400&q=80",
    badge: "Winter",
    size: "lg",
  },
  {
    key: "snow-blower",
    title: "Snow Blowers",
    sub: "Walkways and tight spots cleared fast",
    url: "https://images.unsplash.com/photo-1551477240-20aa0faebd45?auto=format&fit=crop&w=1400&q=80",
    badge: "Winter",
  },
  {
    key: "shovels",
    title: "Shovels & Hand Crews",
    sub: "Steps, entries, the spots machines miss",
    url: "https://images.unsplash.com/photo-1704578424157-223c3ad72870?auto=format&fit=crop&w=1400&q=80",
    badge: "Winter",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    city: "St. Catharines",
    quote:
      "The crew has been mowing our property all season — perfect lines every time and the bin-wash is a game changer.",
  },
  {
    name: "Daniel R.",
    city: "Niagara Falls",
    quote:
      "Plowed our driveway at 5 AM during the worst storm of the year. On time, professional, fair price. We're customers for life.",
  },
  {
    name: "Anita & Joe",
    city: "Welland",
    quote:
      "They transformed our backyard. Fresh sod, mulched beds, hedges sculpted — it doesn't look like the same property.",
  },
];

export const TRUST_POINTS = [
  "Fully insured",
  "Niagara Region locals",
  "Year-round service",
  "Free no-obligation quotes",
  "Eco-conscious products",
  "Residential + commercial",
];

// Add-ons on top of the monthly base lawn care package
export const ADDONS = [
  {
    name: "Edging",
    price: "from $25",
    photo:
      "https://images.unsplash.com/photo-1721138941961-cb245dd928af?auto=format&fit=crop&w=1200&q=80",
  },
  {
    name: "Hedge trimming",
    price: "from $60",
    photo:
      "https://images.pexels.com/photos/24595769/pexels-photo-24595769.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Tree trimming",
    price: "from $80",
    photo:
      "https://images.pexels.com/photos/6232013/pexels-photo-6232013.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Fertilizing",
    price: "from $45",
    photo:
      "https://images.pexels.com/photos/4040853/pexels-photo-4040853.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Aeration",
    price: "from $90",
    photo:
      "https://images.pexels.com/photos/11654274/pexels-photo-11654274.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Mulch refresh",
    price: "from $120",
    photo:
      "https://images.pexels.com/photos/2453600/pexels-photo-2453600.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Weeding",
    price: "from $40",
    photo:
      "https://images.pexels.com/photos/4732350/pexels-photo-4732350.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Garbage bin washing",
    price: "from $25",
    photo:
      "https://images.pexels.com/photos/36086364/pexels-photo-36086364.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    name: "Junk haul-away",
    price: "from $99",
    photo:
      "https://images.pexels.com/photos/7464689/pexels-photo-7464689.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

// Seasonal snow removal packages
export const SNOW_PACKAGES = [
  {
    key: "residential",
    title: "Residential Standard",
    blurb:
      "Ideal for single-family homes and standard driveways. Automatically triggered by a snowfall of 2 inches or more.",
    price: 800,
    priceLabel: "Starting · per season · plus salt fee",
    perks: [
      "Automatic snowfall trigger (2\" or more)",
      "Driveway + walkway clearing",
      "Entrance step clearing",
      "Salting billed separately",
    ],
    badge: "Most popular",
    featured: true,
  },
  {
    key: "premium",
    title: "Premium & Large Properties",
    blurb:
      "Designed for larger estates, long driveways, or properties with extensive walkways. Priority clearing to guarantee access.",
    price: 1800,
    priceLabel: "Starting · per season",
    perks: [
      "Priority queue — cleared first",
      "Long driveways + extended walkways",
      "Multiple entrance points",
      "Salting / de-icing included",
    ],
  },
  {
    key: "commercial",
    title: "Commercial Properties",
    blurb:
      "Tailored for businesses, retail and property management companies. Comprehensive parking lots, sidewalks and entranceways.",
    price: null,
    priceLabel: "Custom quote",
    perks: [
      "Parking lot + drive-aisle clearing",
      "Sidewalks + entranceways",
      "Storm-by-storm reporting",
      "Salting / de-icing programs",
    ],
  },
];

export const SNOW_EXPECT = [
  {
    title: "Automatic service",
    sub: "We monitor the weather and dispatch — you never have to call us when it snows.",
  },
  {
    title: "Full clearing",
    sub: "Driveways, walkways, entrance steps and commercial lots — all in one visit.",
  },
  {
    title: "Salting & de-icing",
    sub: "Optional on every plan to keep surfaces safe and prevent hazardous ice buildup.",
  },
  {
    title: "Lock in your rate",
    sub: "Book early to guarantee priority service and lock in this season's pricing.",
  },
];
